import { api } from '@/api/api'

export const getCurrent = async () => {
  const endpoint = '/api/table/current'
  return await api().get(endpoint).json()
}